import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MyEquipmentToolTip } from '../my-equipment-tooltip/MyEquipmentTooltip';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { CatHeading } from '@blocks-react/components/Heading';
export const MyEquipmentInfoToolTip = ({ children, ariaLabel, label = '', ...toolTipProps }) => {
    return (_jsxs(MyEquipmentToolTip, { ...toolTipProps, children: [_jsx(CatButton, { slot: "trigger", size: "sm", hideText: true, "data-testid": "tooltip-icon", variant: 'ghost', children: _jsx(CatIconInfo, { slot: "after", "aria-label": ariaLabel }) }), _jsxs(CatHeading, { variant: "footnote", children: [children, label] })] }));
};
